import { RootState } from "../store";

export const selectMetrics = (state: RootState) => state.metric;